module.exports = __webpack_public_path__ + "img/VAR_EE.071dd974.png";